import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './BookedForTable.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import StaticTable from '../../../../../../../moreCore/UI/StaticTable/StaticTable';
import { AddressRef, BookedForLoadData, BookedForToBooking, BookedForTranslations, BookedForTypes, BookingTypes, TravelBookingLoadData } from "../../../../TravelBookingListTypes";
import EntityStore from '../../../../../../../moreCore/Tools/EntityStore';
import lang from 'dojo/_base/lang';
import GenericDialog from '../../../../../../../moreCore/UI/GenericDialog/GenericDialog';
import { VAM2types } from "../../../../../../_loadingHelpers/VAMv2Types";
import _GlobalSelectEntityDialogsMixin from '../../../../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import BookedForForm from '../../../../BookedFor/BookedForForm';
import "../../../../BookedFor/BookedForForm";
class BookedForTable extends compose(_WidgetBaseSP, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private entity: TravelBookingLoadData;
    private project: VAM2types.EvProjectEntity_Extended;

    private bookedForType: BookedForTypes;

    private tableContainer: HTMLDivElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;



    private store: MdsLax<InstanceType<typeof EntityStore<BookedForLoadData>>>;

    private tableRowLayout: StaticTable.RowConfig = {
        colNamesInternal: ["booking_no", "bookedFor"],
        "attributes": ["booking_no", "c_booked_for"],
        "headings": [(this as any).translate("TravelBookingForm_Heading_BookingNo"), (this as any).translate("TravelBookingForm_Heading_BookedFor")],
        bgColors: [null, null],
    }

    private tableLayout: StaticTable.Layout = {
        name: "layout",
        label: (this as any).translate("TravelBookingForm_Heading_BookedFor"),
        rows: [(this as any).tableRowLayout],
        layoutStyle: "auto"
    }

    getData(): EntityStoreData<BookedForLoadData> {
        return this.store.getDiffData();
    }

    isStoreEmpty(): boolean {
        return this.store.getCurrentCompleteList().length <= 0;
    }

    setEntity(entity: TravelBookingLoadData) {
        this.entity = entity;
        this.store.setup(this.entity.EL_ht_travel_address_vt_travel);
        this.table.setupFromStore(this.store);
    }

    createTable(project: VAM2types.EvProjectEntity_Extended, bookedForType: BookedForTypes) {
        this.project = project;
        this.bookedForType = bookedForType;

        this.table = new StaticTable();
        this.table.addDefaultRowActionButton("delete");

        this.table.addLayout(this.tableLayout);

        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);

        this.table.setupFromStore(this.store);

        this.table.setRowClick(lang.hitch(this, this._onTableRowClick));
        this.table.setCyAttribute("TravelBookingBookedForTable");
    }

    private setupTable(): void {
        this.tableContainer.innerHTML = null;

        this.table = new StaticTable();
        this.table.addDefaultRowActionButton("delete");

        this.table.addLayout(this.tableLayout);

        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);

        this.table.setupFromStore(this.store);

        this.table.setRowClick(lang.hitch(this, this._onTableRowClick));
        this.table.setCyAttribute("TravelBookingBookedForTable");
    }

    private _onTableRowClick(row: StaticTable.StaticTableRow<BookedForLoadData>) {
        var entity = lang.clone(row.rowGroup.entity);
        var bookedForForm = new BookedForForm();
        bookedForForm.setData(entity);
        var dlg = new GenericDialog();

        dlg.keepOpen = true;
        dlg.show(bookedForForm, entity.$Displayname, null, null, "okcancel", lang.hitch(this, this._onDlgResponse, dlg, bookedForForm));
    }

    deactivateRowClick(): void {
        this.table.setRowClick(lang.hitch(this, this.showSaveFormWarning));
    }

    activateRowClick(): void {
        this.table.setRowClick(lang.hitch(this, this._onTableRowClick));
    }

    private showSaveFormWarning(): void {
        this.showToast(this.translate("TravelBookingForm_Error_SaveForm"), "fas fa-exclamation-triangle");
    }

    private _onDlgResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, bookedForForm: MdsLax<InstanceType<typeof BookedForForm>>, response: number) {
        if (response === 0) {
            dlg.close();
        } else if (response === 1) {
            if (bookedForForm.getIsDirty()) {
                var tempAddress = bookedForForm.updateData();
                if (!this._hasAddressInStore(tempAddress)) {
                    bookedForForm.setAddress(tempAddress);
                    this.table.updateEntity(bookedForForm.getData());
                } else if (tempAddress !== bookedForForm.getData().ref_address) {
                    this.showToast(tempAddress.$Displayname + "," + this.translate("TravelBookingForm_Error_AddressInStore"), "fas fa-exclamation-triangle");
                }
            }
            this.store.changeEntry(lang.clone(bookedForForm.getData()), true);
            dlg.close();
        }
    }

    private _hasAddressInStore(address: AddressRef): boolean {
        var completeList = this.store.getCurrentCompleteList();

        var filteredList = completeList.filter((element) => {
            return element.ref_address.ID === address.ID;
        });

        return filteredList.length > 0;
    }

    getStore() {
        return this.store;
    }

    hasEntities() {
        let completeList = this.store.getCurrentCompleteList();
        return completeList.length > 0;
    }

    //private _getNewBookedForDisplayName(): string {
    //    var displayName: string;
    //    var dateString: string = "";
    //    var dateStartString: string = "";
    //    var dateEndString: string = "";
    //    var locationStartString: string = "";
    //    var locationEndString: string = "";
    //    var locationString: string = "";

    //    if (this.entity) {
    //        if (this.entity["date_start"]) {
    //            dateStartString = this.entity["date_start"].split("T")[0];
    //            var dateStrings = dateStartString.split("-");
    //            dateStartString = dateStrings[2] + "." + dateStrings[1] + "." + dateStrings[0];
    //        } else {
    //            dateStartString = "(?)";
    //        }

    //        if (this.entity["date_end"]) {
    //            dateEndString = this.entity["date_end"].split("T")[0];
    //            var dateStrings = dateEndString.split("-");
    //            dateEndString = dateStrings[2] + "." + dateStrings[1] + "." + dateStrings[0];
    //        } else {
    //            dateEndString = "(?)";
    //        }

    //        if (this.entity.Classname === "flight_bookings" && this.entity["ref_location_start"]) {
    //            locationStartString = this.entity["ref_location_start"].code;
    //        }
    //        if (this.entity.Classname === "flight_bookings" && this.entity["ref_location_end"]) {
    //            locationEndString = this.entity["ref_location_end"].code;
    //        }

    //        if (locationStartString || locationEndString) {
    //            locationString = `(${locationStartString} - ${locationEndString})`;
    //        }

    //        dateString = dateStartString + " - " + dateEndString;
    //        var nameString = this.addressHintbox.getValue("entity") ? this.addressHintbox.getValue("entity").gDisp_Name_Firstname : this.addressHintbox.getValue("plaintext");

    //        displayName = `${nameString} - ${this.entity.ClassPrintname} ${dateString} ${locationString} ${this.project.ev_project_name}`
    //    //} else {
    //    //    //Create date string with no Entity
    //    //    //Use DateStart/DateEnd Input
    //    //    displayName = `${this.addressHintbox.getValue().$Displayname} - ${this.translate(BookedForToBooking[this.bookedForType])} ${dateString} ${this.project.ev_project_name}`
    //    //}

    //    return displayName;
    //}

    private _onClickOpenAddressSED(e): void {
        this.loadSelectEntityDialog(e,
            "selectVtAddresses",
            lang.hitch(this, this._onCallbackSED),
            null,
            { evProject: this.project.ID }
        );
    }

    private _onCallbackSED(mode: string, data, items): void {
        if (items) {
            items.forEach(item => {
                var tableData: BookedForLoadData;
                if (this.entity) {
                    tableData = {
                        ID: String(Math.round(Math.random() * 100000)),
                        Classname: this.bookedForType,
                        ClassPrintname: this.translate(BookedForTranslations[this.bookedForType]),
                        $Displayname: item.entry.data.$Displayname,
                        ref_vt_travel: this.entity,
                        ref_address: item.entry.data,
                        c_booked_for: item.entry.data.gDisp_Name_Firstname,
                        qty_persons: 1,
                        ref_relation_type: null,
                        ref_smoking_attitude: null,
                        c_relation_type: null,
                        note: "",
                        note_internal_use: "",
                        booking_no: "",
                        ref_travel_bookingstatus: null,
                    };
                } else {
                    tableData = {
                        ID: String(Math.round(Math.random() * 100000)),
                        Classname: this.bookedForType,
                        ClassPrintname: this.translate(BookedForTranslations[this.bookedForType]),
                        $Displayname: item.entry.data.$Displayname,
                        ref_address: item.entry.data,
                        c_booked_for: item.entry.data.gDisp_Name_Firstname,
                        ref_vt_travel: {
                            $Displayname: null,
                            Classname: null,
                            ClassPrintname: null,
                            ID: null,
                            ref_ev_project: this.project as any
                        },
                        qty_persons: 1,
                        ref_relation_type: null,
                        ref_smoking_attitude: null,
                        c_relation_type: null,
                        note: "",
                        note_internal_use: "",
                        booking_no: "",
                        ref_travel_bookingstatus: null
                    }
                }
                if (!this._hasAddressInStore(tableData.ref_address)) {
                    this.store.addEntry(tableData);
                } else {
                    this.showToast(this.translate("TravelBookingForm_Error_AddressInStore"), "fas fa-exclamation-triangle");
                }
            });
        }
    }

    private _onStoreChange(): void {
        this.emit("change", this.store.isDirty());
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.store = new EntityStore<BookedForLoadData>();

        this.store.on("change", lang.hitch(this, this._onStoreChange));
        this.store.on("delete", lang.hitch(this, this._onStoreChange));
        this.store.on("added", lang.hitch(this, this._onStoreChange));

        this.SEDconfigCallfunction = "Webtool_API__TravelBookingForm_SED_GetConfig";

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(BookedForTable);